function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/* eslint-disable semi */
/* eslint-disable quotes */
// DEPRECATED COMPONENT, DO NOT USE. USE APP-COMPONENTS Filter INSTEAD.
import React, { forwardRef, useState, useEffect, useRef, useCallback, useImperativeHandle } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classNames from 'classnames';
import Humanize from 'humanize-plus';
import { SelectionBubble, Icon } from '@unite-us/ui';
import { ClearSelections, FilterOption, NoMatches, Search, SelectAll } from "./components";
import { buildOptions, countOptions, createFilterId, filterOptions, getInitialFilters, isMultiLevel } from "./utils";
/**
 * @visibleName Filter DEPRECATED
*/
var Filter = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var className = _ref.className,
    filterKey = _ref.filterKey,
    filterSearchOptions = _ref.filterSearchOptions,
    mustHaveOneSelected = _ref.mustHaveOneSelected,
    hideSelectAll = _ref.hideSelectAll,
    isSingleOptionSelect = _ref.isSingleOptionSelect,
    name = _ref.name,
    pluralName = _ref.pluralName,
    onFiltersChange = _ref.onFiltersChange,
    asyncSearch = _ref.asyncSearch,
    asyncSearchDebounce = _ref.asyncSearchDebounce,
    asyncLoadingText = _ref.asyncLoadingText,
    options = _ref.options,
    optionsRenderLimit = _ref.optionsRenderLimit,
    noMatchesPlaceholder = _ref.noMatchesPlaceholder,
    searchPlaceholder = _ref.searchPlaceholder,
    uniqIdPrefix = _ref.uniqIdPrefix,
    dataTestId = _ref.dataTestId;
  var _useState = useState(options),
    _useState2 = _slicedToArray(_useState, 2),
    optionsState = _useState2[0],
    setOptionsState = _useState2[1];
  var _useState3 = useState(getInitialFilters(options)),
    _useState4 = _slicedToArray(_useState3, 2),
    activeFilters = _useState4[0],
    setActiveFilters = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    selectedOptions = _useState6[0],
    setSelectedOptionsState = _useState6[1];
  var activeFiltersRef = useRef(activeFilters);
  var selectedOptionsRef = useRef(selectedOptions);
  var _useState7 = useState(optionsState),
    _useState8 = _slicedToArray(_useState7, 2),
    availableOptions = _useState8[0],
    setAvailableOptions = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    loading = _useState10[0],
    setLoading = _useState10[1];
  var loadingRef = useRef(loading);
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    open = _useState12[0],
    setOpen = _useState12[1];
  var _useState13 = useState(''),
    _useState14 = _slicedToArray(_useState13, 2),
    search = _useState14[0],
    setSearch = _useState14[1];
  var _useState15 = useState(countOptions(options)),
    _useState16 = _slicedToArray(_useState15, 2),
    totalOptionsCount = _useState16[0],
    setTotalOptionsCount = _useState16[1];
  var filterWrapperRef = useRef(null);
  var searchFieldRef = useRef(null);
  var setAvailableAndSelectedOptions = function setAvailableAndSelectedOptions() {
    var newAvailableOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var newOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var updatedAvailableOptions = newAvailableOptions.filter(function (opt) {
      return activeFiltersRef.current.indexOf(opt.value) < 0;
    });
    var canBeSelectedOptions = _.uniqBy([].concat(_toConsumableArray(selectedOptionsRef.current), _toConsumableArray(newOptions)), 'value');
    var updatedSelectedOptions = canBeSelectedOptions.filter(function (opt) {
      return activeFiltersRef.current.indexOf(opt.value) >= 0;
    });
    setAvailableOptions(optionsRenderLimit < 0 ? updatedAvailableOptions : _.take(updatedAvailableOptions, optionsRenderLimit));
    setSelectedOptionsState(updatedSelectedOptions);
    setLoading(false);
  };
  var getAvailableOptions = function getAvailableOptions() {
    var newOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    if (isMultiLevel(newOptions)) {
      return buildOptions({
        options: newOptions,
        selected: activeFiltersRef.current
      });
    }
    return newOptions;
  };
  var asyncFilterOptions = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(searchValue) {
      var fetchedOptions, available;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return asyncSearch(searchValue);
          case 3:
            fetchedOptions = _context.sent;
            available = getAvailableOptions(fetchedOptions);
            setAvailableAndSelectedOptions(available, fetchedOptions);
            setOptionsState(fetchedOptions);
            _context.next = 12;
            break;
          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](0);
            setAvailableAndSelectedOptions([], []);
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 9]]);
    }));
    return function asyncFilterOptions(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var debouncedAsyncFilterOptions = useCallback(_.debounce(asyncFilterOptions, asyncSearchDebounce), []);
  var localFilterOptions = function localFilterOptions() {
    var optionsToFilter = optionsState;
    if (isMultiLevel(optionsToFilter)) {
      optionsToFilter = buildOptions({
        options: optionsToFilter,
        selected: activeFilters
      });
    }
    var available = optionsToFilter;
    if (!_.isEmpty(search)) {
      var filteredOptions = filterSearchOptions ? filterSearchOptions(optionsState, search) : filterOptions(optionsState, search);
      available = getAvailableOptions(filteredOptions);
    }
    setAvailableAndSelectedOptions(available, optionsToFilter);
  };
  var onSearchChange = function onSearchChange(value) {
    if (asyncSearch) {
      if (search !== value) {
        setSearch(value || '');
        setLoading(true);
        setAvailableOptions([]);
        debouncedAsyncFilterOptions(value);
      }
    } else {
      setSearch(value || '');
      localFilterOptions();
    }
  };
  useEffect(function () {
    activeFiltersRef.current = activeFilters;
    selectedOptionsRef.current = selectedOptions;
    loadingRef.current = loading;
  }, [activeFilters, selectedOptions, loading]);
  useEffect(function () {
    var setActiveFiltersAndOptionsCount = function setActiveFiltersAndOptionsCount() {
      var initialFilters = getInitialFilters(options);
      setActiveFilters(initialFilters);
      setTotalOptionsCount(countOptions(options));
      localFilterOptions();
      setOptionsState(options);
    };
    if (!open && !_.isEqual(options, optionsState)) {
      setActiveFiltersAndOptionsCount();
    }
  }, [options]);
  useEffect(function () {
    var onClickOutside = function onClickOutside(e) {
      if (open) {
        var path = e.path || e.composedPath && e.composedPath();
        var index = _.findIndex(path, filterWrapperRef.current);
        if (path && index < 0) {
          setOpen(false);
        }
      }
    };
    document.addEventListener('click', onClickOutside);
    setOptionsState(options);
    localFilterOptions();
    return function () {
      document.removeEventListener('click', onClickOutside);
    };
  }, [open]);
  useEffect(function () {
    localFilterOptions();
  }, [activeFilters]);
  useEffect(function () {
    return function () {
      debouncedAsyncFilterOptions.cancel();
    };
  }, [debouncedAsyncFilterOptions]);
  useEffect(function () {
    onSearchChange(search);
  }, [search]);
  var onButtonClick = function onButtonClick(e) {
    e.preventDefault();
    if (!open) {
      searchFieldRef.current.resetValue();
    }
    setOpen(!open);
  };
  var _setSelectedOptions = function setSelectedOptions(optionIds) {
    var newSelectedOptions = optionIds.map(function (id) {
      return options.find(function (o) {
        return o.value === id;
      });
    }).filter(function (o) {
      return o !== undefined;
    });
    setSelectedOptionsState(newSelectedOptions);
    setActiveFilters(optionIds);
  };
  useImperativeHandle(ref, function () {
    return {
      props: {
        filterKey: filterKey
      },
      setSelectedOptions: function setSelectedOptions(values) {
        _setSelectedOptions(values);
      }
    };
  }, []);
  var onOptionChange = function onOptionChange(filter, value) {
    var optValue = filter.value;
    var newFilters = _.without(activeFilters, optValue);
    var newSelected = _.without(selectedOptions, filter);
    if (isSingleOptionSelect && value != null) {
      newFilters = [optValue];
      newSelected = [filter];
    } else if (value) {
      newFilters = newFilters.concat(optValue);
      newSelected = newSelected.concat(filter);
    }
    setActiveFilters(newFilters);
    setSelectedOptionsState(newSelected);
    onFiltersChange(newFilters, filterKey, {
      setSelectedOptions: _setSelectedOptions,
      filterKey: optValue
    });
    localFilterOptions();
  };
  var onSelectAll = function onSelectAll() {
    var optionsToSelect = options;
    if (isMultiLevel(optionsToSelect)) {
      optionsToSelect = buildOptions({
        options: optionsToSelect,
        selected: activeFilters
      });
    }
    var newFilters = _.reduce(optionsToSelect, function (acc, o) {
      if (!_.get(o, 'hasChildren', false)) {
        return acc.concat(o.value);
      }
      return acc;
    }, []);
    setActiveFilters(newFilters);
    localFilterOptions();
    onFiltersChange(newFilters, filterKey, _setSelectedOptions);
  };
  var onClearAll = function onClearAll() {
    setActiveFilters([]);
    localFilterOptions();
    onFiltersChange([], filterKey, {
      setSelectedOptions: _setSelectedOptions
    });
  };
  var filterClass = classNames({
    'max-w-350px min-w-250px relative': true
  }, className);
  var allOptionsSelected = activeFilters.length >= totalOptionsCount;
  var noMatchesFound = availableOptions.length <= 0;
  var filterButtonClass = classNames('font-regular text-sm block min-h-2.25rem px-2.125 pl-2.5 py-0 relative text-left select-none w-full border border-solid', {
    'rounded-t border-united-blue  overflow-hidden': open
  }, {
    rounded: !open
  }, {
    'bg-light-border-blue hover:bg-dark-fill-blue border-filter-border-color': !open && !_.isEmpty(selectedOptions)
  }, {
    'hover:bg-medium-fill-grey bg-white border-light-border-blue': !open && _.isEmpty(selectedOptions)
  });
  var dropdownClass = classNames('', {
    'block bg-white absolute from-white to-light-border-grey rounded-b border border-t-0 border-solid border-united-blue z-dropdown overflow-hidden left-0 right-0 top full': open
  }, {
    'hidden border-light-border-blue left-0 right-0 top-full border-t-0 border': !open
  });
  var countClass = classNames({
    'inline-block ml-1 font-bold font-heavy-font': true
  }, {
    hidden: selectedOptions.length === 0
  });
  var checkIconClass = classNames({
    'inline-block mr-2': true
  }, {
    hidden: selectedOptions.length <= 0
  });
  var count = selectedOptions.length;
  var accessibilityLabel = "".concat(Humanize.titleCase(Humanize.pluralize(count || 1, name, pluralName)), " (").concat(count, ") selected, dropdown");
  return /*#__PURE__*/React.createElement("div", {
    className: filterClass,
    id: "".concat(createFilterId(name), "-container"),
    ref: filterWrapperRef
  }, /*#__PURE__*/React.createElement("button", {
    role: "listbox",
    onClick: onButtonClick,
    className: filterButtonClass,
    "aria-label": accessibilityLabel,
    "data-testid": dataTestId
  }, /*#__PURE__*/React.createElement("span", {
    className: checkIconClass
  }, /*#__PURE__*/React.createElement(Icon, {
    className: "mb-1",
    color: "#2C405A",
    viewBox: "0 0 20 20",
    icon: "IconCheck",
    size: 14
  })), Humanize.titleCase(Humanize.pluralize(count || 1, name, pluralName)), /*#__PURE__*/React.createElement("span", {
    className: countClass
  }, "(", /*#__PURE__*/React.createElement("span", {
    className: "mr-0.2 font-bold font-heavy-font"
  }, count), ")"), open ? /*#__PURE__*/React.createElement(Icon, {
    className: "absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    icon: "IconCaretUp",
    size: 16,
    color: "#333333"
  }) : /*#__PURE__*/React.createElement(Icon, {
    className: "absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    icon: "IconCaretDown",
    size: 16,
    color: "#67859E"
  })), /*#__PURE__*/React.createElement("div", {
    className: dropdownClass
  }, /*#__PURE__*/React.createElement(Search, {
    id: createFilterId(name),
    label: "Search ".concat(name),
    onChange: onSearchChange,
    placeholder: searchPlaceholder,
    ref: searchFieldRef
  }), /*#__PURE__*/React.createElement("div", {
    className: "overflow-y-auto select-none max-h-450px relative"
  }, !_.isEmpty(selectedOptions) ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "flex-wrap px-4 pt-3"
  }, selectedOptions.map(function (o) {
    return /*#__PURE__*/React.createElement(SelectionBubble, {
      key: "uOpt-".concat(o.value, "-selected"),
      label: o.label,
      hideClose: mustHaveOneSelected && count === 1,
      selected: o,
      onClick: onOptionChange
    });
  })), mustHaveOneSelected ? /*#__PURE__*/React.createElement("div", {
    className: "border-b border-light-border-blue"
  }) : /*#__PURE__*/React.createElement(ClearSelections, {
    onClick: onClearAll,
    allOptionsSelected: allOptionsSelected
  })) : null, /*#__PURE__*/React.createElement("div", null, loadingRef.current && /*#__PURE__*/React.createElement("div", {
    className: "pt-3 pl-2.5 pb-2.5 text-initial box-content block font-regular-font capitalize text-brand-blue tracking-normal"
  }, asyncLoadingText), /*#__PURE__*/React.createElement(SelectAll, {
    hide: hideSelectAll || noMatchesFound || allOptionsSelected || optionsRenderLimit > 0,
    onSelectAll: onSelectAll
  }), availableOptions.map(function (o) {
    return /*#__PURE__*/React.createElement(FilterOption, {
      selected: _.indexOf(activeFilters, o.value) >= 0,
      key: "uOpt-".concat(o.value),
      onChange: onOptionChange,
      option: o,
      searchTerm: search,
      uniqIdPrefix: uniqIdPrefix
    });
  }), /*#__PURE__*/React.createElement(NoMatches, {
    noMatchesFound: !loading && (allOptionsSelected || noMatchesFound),
    placeholder: noMatchesPlaceholder
  })))));
});
Filter.propTypes = {
  /** className for reference */
  className: PropTypes.string,
  /** Filter key used when storing selected filter to state. i.e. serviceTypes */
  filterKey: PropTypes.string,
  /** returns an array of filtered searched ServiceType options */
  filterSearchOptions: PropTypes.func,
  /** Don't allow user to remove all options */
  mustHaveOneSelected: PropTypes.bool,
  /** Should hide select all button */
  hideSelectAll: PropTypes.bool,
  /** Only allows one option to be selected at a time */
  isSingleOptionSelect: PropTypes.bool,
  /** Singular name to display on Filter button (i.e. 'Population') */
  name: PropTypes.string.isRequired,
  /** Plural name to display on Filter in case Humanize can't handle it */
  pluralName: PropTypes.string,
  /**
   * @param {array} activeFilters array of selected filters
   * @param {string} key filterKey
   * @public
  */
  onFiltersChange: PropTypes.func.isRequired,
  /**
   * Accepts Promise resolving an array of formatted options
   * @param {string} search
  */
  asyncSearch: PropTypes.func,
  /** Debouce wait for the asyncSearch */
  asyncSearchDebounce: PropTypes.number,
  /** Async loading text displayed while waiting for the promise */
  asyncLoadingText: PropTypes.string,
  /** Array of filter options objects */
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    initial: PropTypes.bool,
    selectionDisabled: PropTypes.bool,
    children: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      initial: PropTypes.bool,
      selectionDisabled: PropTypes.bool
    }))
  })).isRequired,
  /** Maximum number of options to render in case of long options array (-1 is unlimited) */
  optionsRenderLimit: PropTypes.number,
  /** Placeholder text for when no matches are found */
  noMatchesPlaceholder: PropTypes.string,
  /** Placeholder text for search */
  searchPlaceholder: PropTypes.string,
  /** A prefix to prevent ID conflicts when multiple filters share the same option list */
  uniqIdPrefix: PropTypes.string,
  /** Immutable identifier for testing */
  dataTestId: PropTypes.string
};
Filter.defaultProps = {
  className: '',
  filterKey: '',
  filterSearchOptions: undefined,
  asyncSearch: undefined,
  mustHaveOneSelected: false,
  hideSelectAll: false,
  isSingleOptionSelect: false,
  optionsRenderLimit: -1,
  noMatchesPlaceholder: 'No Results Found',
  pluralName: null,
  searchPlaceholder: 'Search',
  uniqIdPrefix: '',
  asyncSearchDebounce: 500,
  asyncLoadingText: 'Loading...',
  dataTestId: ''
};
Filter.displayName = 'Filter';
export default Filter;